import { Component, OnInit } from '@angular/core';
import { ViewController, Platform, NavController, NavParams } from 'ionic-angular';
import { Localization } from '../../app/app.localization'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Generated class for the ConfirmOrderModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'confirm-order-modal',
  templateUrl: 'confirm-order-modal.html'
})
export class ConfirmOrderModalComponent implements OnInit {
    title: string;
    subTitles: string[];
    bottomButton: string;
    bottomOkCancel: boolean;
    customHtmlCode: SafeHtml;

    constructor(
        public platform: Platform,
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        private _loc: Localization,
        private sanitizer: DomSanitizer,
    ) {
        this.title = navParams.get('title') ? navParams.get('title') : "";
        this.subTitles = navParams.get('subTitles') ? navParams.get('subTitles') : null;
        this.bottomButton = navParams.get('bottomButton') ? navParams.get('bottomButton') : "";
        this.bottomOkCancel = navParams.get('bottomOkCancel') ? true : false;
        this.customHtmlCode = navParams.get('customHtmlCode') ? sanitizer.bypassSecurityTrustHtml(navParams.get('customHtmlCode')) : "";
    }

    closeModal(data: any) {
        this.viewCtrl.dismiss(data);
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/components/confirm-order-modal/confirm-order-modal.ts